module.exports = __webpack_public_path__ + "img/logo_dark@1x.cafb5526.png";